export default __webpack_public_path__ + "static/manInFrontOfComputer-27ee4c37f77d045893a2f3013be52cb3.svg";